import MuiGrid from "@mui/material/Grid";
import type { GridProps as MuiGridProps } from "@mui/material/Grid";

export type GridItemProps = MuiGridProps;

export function GridItem({
  children,
  columns,
  sx,
  xs,
  md,
  lg,
  xl,
  wrap,
  minWidth,
  minHeight,
  maxWidth,
  maxHeight,
  zeroMinWidth,
  justifyContent = "space-between",
  alignItems = "center",
  alignSelf,
  display,
}: GridItemProps) {
  return (
    <MuiGrid
      columns={columns}
      item
      sx={sx}
      xs={xs}
      md={md}
      lg={lg}
      xl={xl}
      wrap={wrap}
      minWidth={minWidth}
      minHeight={minHeight}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      zeroMinWidth={zeroMinWidth}
      justifyContent={justifyContent}
      alignSelf={alignSelf}
      alignItems={alignItems}
      display={display}
    >
      {children}
    </MuiGrid>
  );
}
